import { initializeAppCheck, ReCaptchaV3Provider, AppCheck } from 'firebase/app-check';
import { FirebaseApp } from 'firebase/app';
import { RECAPTCHA_SITE_KEY } from '../resources/constants';

// Variabile per memorizzare l'istanza di App Check
let appCheckInstance: AppCheck | null = null;

/**
 * Inizializza Firebase App Check
 * Deve essere chiamato dopo l'inizializzazione dell'app Firebase
 */
export const initializeFirebaseAppCheck = (app: FirebaseApp): AppCheck | null => {
    // Verifica se la chiave reCAPTCHA è configurata
    if (!RECAPTCHA_SITE_KEY || RECAPTCHA_SITE_KEY === 'YOUR_RECAPTCHA_SITE_KEY') {
        console.warn(
            '⚠️ Firebase App Check non è stato inizializzato: chiave reCAPTCHA mancante o non valida.\n' +
                'Per abilitare App Check:\n' +
                '1. Vai su Firebase Console > App Check\n' +
                '2. Registra la tua app web\n' +
                '3. Configura reCAPTCHA v3\n' +
                '4. Aggiungi la chiave in .env: REACT_APP_RECAPTCHA_ID=la_tua_chiave',
        );
        return null;
    }

    // In development, abilita il debug token
    if (process.env.NODE_ENV === 'development') {
        // Per usare il debug token in sviluppo, decommenta questa riga
        // e segui le istruzioni nella console Firebase
        //self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }

    try {
        // Inizializza Firebase App Check con ReCAPTCHA v3
        appCheckInstance = initializeAppCheck(app, {
            provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
            // Auto-refresh del token per mantenere sempre un token valido
            isTokenAutoRefreshEnabled: true,
        });

        console.log('✅ Firebase App Check inizializzato correttamente');
        return appCheckInstance;
    } catch (error) {
        console.error("❌ Errore durante l'inizializzazione di Firebase App Check:", error);
        return null;
    }
};

/**
 * Ottieni l'istanza di App Check (deve essere inizializzata prima)
 * Restituisce null se App Check non è stato inizializzato (chiave mancante)
 */
export const getAppCheck = (): AppCheck | null => {
    return appCheckInstance;
};

/**
 * Verifica se App Check è abilitato
 */
export const isAppCheckEnabled = (): boolean => {
    return appCheckInstance !== null;
};
